import { EnvelopeIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import { contacts, footerLinks } from "../assets/footer";
import ContactDetails from "./ContactDetails";
import FooterLink from "./FooterLink";
import Facebook from "./Icons/Facebook";
import Instagram from "./Icons/Instagram";
import Linkedin from "./Icons/Linkedin";

export default function Footer() {
  return (
    <footer className="bg-black">
      <div className="grid grid-cols-4 lg:grid-cols-12 gap-4 lg:gap-8 gap-y-8 xl:justify-between md:px-15 lg:py-20 xl:px-30 py-8 text-gray-50 lg:px-20 px-6">
        <div className="grid grid-cols-subgrid lg:flex lg:flex-col col-span-4 lg:col-span-3 lg:col-start-1 justify-between lg:items-start">
          <div className="flex lg:flex-col col-span-4 h-full self-start">
            <div className="col-span-2 self-center">
              <Link to={`/`} className="flex justify-center">
                <img
                  src="/images/CultivLogo.svg"
                  className="w-3/4 md:w-1/5 lg:w-2/3 self-center"
                  alt="Cultiv square logo"
                  width={76}
                  height={68}
                />
              </Link>
            </div>
            <div className="col-span-2 flex flex-col items-end lg:items-center justify-between h-full w-full">
              <a
                href="mailto:info@cultiv.llc"
                className="order-2 lg:order-1 lg:h-full lg:content-center hover:text-cultiv-yellow duration-300 ease-in-out"
              >
                <div className="flex gap-1 lg:gap-2.5 items-center lg:justify-center">
                  <EnvelopeIcon
                    className="w-4 h-4 lg:w-6 lg:h-6"
                    height={24}
                    width={24}
                  ></EnvelopeIcon>
                  <p className="text-xs md:text-sm lg:text-xl">info@cultiv.llc</p>
                </div>
              </a>
              <div className="flex gap-3 lg:gap-7.5 lg:justify-between order-1 lg:order-2 items-center">
                <a
                  href="https://www.linkedin.com/company/cultivllc"
                  target="_blank"
                  aria-label="Go to cultiv's Linkedin page"
                >
                  <Linkedin color="white" hoverColor="cultiv-yellow" />
                </a>
                <a
                  href="https://www.facebook.com/cultivllc"
                  target="_blank"
                  aria-label="Go to cultiv's Facebook page"
                >
                  <Facebook color="white" hoverColor="cultiv-yellow" />
                </a>
                {/* <a
                href="https://twitter.com/CultivLLC"
                target="_blank"
                aria-label="Go to cultiv's X account"
              >
                <Twitter color="white" hoverColor="cultiv-yellow" />
              </a> */}
                <a
                  href="https://www.instagram.com/cultiv.llc/"
                  target="_blank"
                  aria-label="Go to cultiv's Instagram account"
                >
                  <Instagram color="white" hoverColor="cultiv-yellow" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col col-span-full lg:col-span-3 lg justify-evenly gap-3 lg:gap-10">
          <h2 className="text-lg sm:text-xl md:text-2xl xl:text-3xl font-bold uppercase font-expanded whitespace-nowrap">
            Quick links
          </h2>
          <div className="flex flex-col justify-between gap-3 lg:gap-2 h-full ">
            {footerLinks.map((link, index) => {
              return <FooterLink key={index} title={link.title} pathname={link.pathname} />;
            })}
          </div>
        </div>
        <div className="flex flex-col col-span-full lg:col-span-5 lg:col-start-8 items-start gap-3 lg:gap-10">
          <h2 className="text-lg sm:text-xl md:text-2xl xl:text-3xl font-bold font-expanded uppercase">
            Find Us
          </h2>
          <div className="flex flex-col justify-between h-full gap-4">
            {contacts.map((contact, index) => {
              return <ContactDetails key={index} name={contact} />;
            })}
          </div>
        </div>
      </div>
    </footer>
  );
}
